import React from 'react'
import classnames from 'classnames'
import {
  CardCvcElementComponent,
  CardExpiryElementComponent,
  ElementProps,
} from '@stripe/react-stripe-js'

import Input, { baseInputStyles, InputProps } from 'components/Input'
import commonStyles, { invalidStyles } from './commonStyles'
import styled from 'styled-components'

const BaseInput = styled(Input)<InputProps>`
  ${baseInputStyles};
`

interface StripeInputProps extends ElementProps {
  disabled?: boolean
  invalid?: boolean
}

const createInput = (
  Element: CardCvcElementComponent | CardExpiryElementComponent
) => {
  const BaseElement = styled(Element)`
    flex: 1;
    height: 40px;
    padding-top: 2px; /* stylelint-disable-line scales/space */
  `

  const StripeInput = (props: StripeInputProps) => (
    <BaseInput
      /*
      Stripe sometimes removes the className from the wrapper div.
      Forcing it like this will prevent this behaviour
      */
      className={classnames('StripeElement', props.className)}
      disabled={props.disabled ?? false}
      invalid={props.invalid}
      as="div">
      <BaseElement
        options={{
          style: props.invalid ? invalidStyles() : commonStyles(),
        }}
        {...props}
      />
    </BaseInput>
  )

  return StripeInput
}

export default createInput
